import React from "react";

const LoginStats = () => {
  return (
    <div className="case-studies-container">
      <div className="stats-section mt-8">
        <div className="stats-container d-flex justify-content-center">
          <div className="stats-item mx-4 text-center">
            <div className="stats-number text-success font-size-h2">200+</div>
            <div className="stats-label text-muted">Teams</div>
          </div>
          <div className="stats-item mx-4 text-center">
            <div className="stats-number text-primary font-size-h2">7000+</div>
            <div className="stats-label text-muted">Athletes</div>
          </div>
        </div>
        <div className="stats-description mt-4 text-center">
          <h4>Proudly supporting leading Sports Organizations</h4>
        </div>
      </div>
    </div>
  );
};

export default LoginStats;
